import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  Label,
  Input,
} from "reactstrap";
import { IoIosRefresh } from "react-icons/io";
import InputPassword from "../InputPassword";
import InputField from "../InputField";
import { DatePicker } from "reactstrap-date-picker";
import { MdOutlineDateRange } from "react-icons/md";

function PasswordForm(props) {
  const { formik = {} } = props;
  // console.log(formik.errors, formik.values);

  return (
    <Modal
      isOpen={props.passwordModal}
      toggle={props.passwordModaltoggle}
      size="lg"
      centered
    >
      <ModalHeader toggle={props.passwordModaltoggle}>
        Add New Password
      </ModalHeader>
      <ModalBody>
        <Form className="formWrap">
          <div className="row">
            <div className="col-6">
              <div className="formSelectWrap">
                <Label>Password Type</Label>
                <Input
                  id="passwordType"
                  name="passwordType"
                  type="select"
                  readOnly={props?.isEdit}
                  value={props.passwordType}
                  onChange={(e) => {
                    if (!props?.isEdit) {
                      props?.setPasswordType(e.target.value);
                      formik.resetForm();
                      formik.setFieldValue(
                        "passwordType",
                        e.target.value
                      );
                    }
                  }}
                >
                  <option value="APIs">APIs</option>
                  <option value="Database Access">
                    Database Access
                  </option>
                  <option value="Web Applications">
                    Web Applications
                  </option>
                  <option value="Server Access">Server Access</option>
                  <option value="Cloud Services">
                    Cloud Services
                  </option>
                  <option value="Others">Others</option>
                </Input>
              </div>
            </div>
            <div className="col-6">
              <div className="formSelectWrap">
                <InputField
                  formik={formik}
                  name={"identifier"}
                  placeholder={"Identifier"}
                  type={"text"}
                  value={formik.values.identifier}
                  touch={formik.touched.identifier}
                  error={formik.errors.identifier}
                />
              </div>
            </div>
          </div>
          <InputPassword
            passwordVisible={props?.passwordVisible}
            // passwordValue={props?.passwordValue}
            passwordType={props?.passwordType}
            toggleGeneratePass={() => props?.toggleGeneratePass()}
            togglePassword={() => props?.togglePassword()}
            formik={props?.formik}
            handleFileChange={(e) => props?.handleFileChange(e)}
          />
          {props?.generatePassVisible && (
            <div className="row generateRow">
              <div className="col-12">
                <div className="generateWrap">
                  <Input
                    id=""
                    name=""
                    placeholder=""
                    type="number"
                    value={props?.passwordLength}
                    onChange={(e) =>
                      props?.setPasswordLength(e.target.value)
                    }
                  />
                  <Button
                    className={
                      props?.uppercaseCheck
                        ? "generateBtn active"
                        : "generateBtn"
                    }
                    onClick={() => props?.uppercaseChecktoggle()}
                  >
                    [ A-Z ]
                  </Button>
                  <Button
                    className={
                      props?.lowercaseCheck
                        ? "generateBtn active"
                        : "generateBtn"
                    }
                    onClick={() => props?.lowercaseChecktoggle()}
                  >
                    [ a-z ]
                  </Button>
                  <Button
                    className={
                      props?.numberCheck
                        ? "generateBtn active"
                        : "generateBtn"
                    }
                    onClick={() => props?.numberChecktoggle()}
                  >
                    [ 0-9 ]
                  </Button>
                  <Button
                    className={
                      props?.symbolCheck
                        ? "generateBtn active"
                        : "generateBtn"
                    }
                    onClick={() => props?.symbolChecktoggle()}
                  >
                    [ ~!@-+ ]
                  </Button>

                  <Button
                    className="refreshBtn"
                    onClick={() => props?.onRefresh()}
                  >
                    <IoIosRefresh />
                  </Button>
                </div>
              </div>
            </div>
          )}
          <div>
            {/* <div className="formSelectWrap "> */}
            <div className="formElmWrap mb-3 dateWrap">
              <div className="formSelectWrap ">
                <Label>Expiry Date</Label>
                <DatePicker
                  showClearButton={true}
                  placeholder="Expiry Date"
                  minDate={new Date().toDateString() + 86400000}
                  value={formik.values.pwExpiryDate}
                  onChange={(e) =>
                    formik.setFieldValue(
                      "pwExpiryDate",
                      e?.split("T")[0]
                    )
                  }
                />
                <span className="formIcon dateIcon">
                  {<MdOutlineDateRange />}
                </span>
                {formik.touched.pwExpiryDate &&
                formik.errors.pwExpiryDate ? (
                  <Label style={{ color: "red" }}>
                    {formik.errors.pwExpiryDate}
                  </Label>
                ) : null}
              </div>
              {/* </div> */}
            </div>
          </div>
          <div>
            <div className="formSelectWrap">
              <InputField
                formik={formik}
                name={"note"}
                placeholder={"Keynote"}
                type={"textarea"}
                value={formik.values.note}
                touch={formik.touched.note}
                error={formik.errors.note}
                rows={7}
              />
            </div>
          </div>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={formik.handleSubmit}>
          Submit
        </Button>
        <Button color="outline" onClick={props.passwordModaltoggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default PasswordForm;
